import state from './moduleCampaignBannerState'
import actions from './moduleCampaignBannerActions'
import getters from './moduleCampaignBannerGetters'
import mutations from './moduleCampaignBannerMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

